export default __webpack_public_path__ + "static/tiguan-99586b840f315accae663b80118f5ce9.pdf";